import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { Account } from '../models/account';
import { UserService } from '../services/user/user.service';


@Component({
  selector: 'app-api-keys',
  templateUrl: './api-keys.component.html',
  styleUrls: ['./api-keys.component.css']
})
export class ApiKeysComponent implements OnInit {

  modalRef!: BsModalRef;

  accounts: Account[];
  accountId = null;
  apiKeys: [] = []
  clientName: string;
  totalRecords: number = 0;
  accountSerach: string = "";
  clientNameSearch: string = "";
  ClientIdSearch: string = "";
  isSearchMode: boolean = false;
  offset: number = 0;

  constructor(public accountService: AccountService,
    public foruscareService: ForuscareService,
    public userService: UserService,
    private modalService: BsModalService) { }

  ngOnInit(): void {
    this.getAvailableAccounts();
    this.getClientApiKeys(0);
  }

  getClientApiKeys(offset: any) {
    let count = 10;
    this.userService.getClientKeys(count, offset).subscribe((response: any) => {
      if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
        if (response.data != null) {
          if (response.data.response.length > 0) {
            this.apiKeys = response.data.response;
            this.totalRecords = response.data.totalCount;
          }
        }
      }
      else {
        this.foruscareService.showNotification(response.message, "danger");
      }

    })
  }

  // To get the all available account list
  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {

              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  onPageChange(event) {
    let offset = event.first;
    if (this.isSearchMode) {
      return;
    }
    this.offset = offset;
    this.getClientApiKeys(offset);
  }

  generateNewApiKey(ApiKeyGenerateModal: TemplateRef<any>) {
    this.accountId = null;
    this.clientName = null
    const config = {
      class: 'modal-lg'
    };
    this.modalRef = this.modalService.show(ApiKeyGenerateModal, config);
  }

  onGenerateClick() {
    let accountId = this.accountId;
    let clientName = this.clientName;
    if (accountId == null || clientName == null) {
      this.foruscareService.showNotification("Please fill both fields", "danger");
      return;
    }
    const tagPattern = /<[^>]*>/g;
    if (tagPattern.test(clientName)) {
      this.foruscareService.showNotification("HTML tags are not allowed in Client Name.", "danger");
      return;
    }
    this.userService.generateClientKey(accountId, clientName).subscribe((response: any) => {
      if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
        if (response.data != null) {
          this.modalRef.hide();
          this.getClientApiKeys(0);
          this.foruscareService.showNotification("Client key generated successfully", "success");
          this.accountId = null;
          this.clientName = null;
        }
      } else if (response.errorCode == 409) {
        this.foruscareService.showNotification("Account and Client Name must be unique. Please provide different values.", "danger");
      }
      else {
        const errorMessage = response?.message || "Something went wrong, please try again later!";
        this.foruscareService.showNotification(errorMessage, "danger");
      }
    });
  }

  setKeyStatus(event: any) {
    let clientKeyId = event.id;
    let status = event.status == true ? "enable" : "disable";
    this.userService.setClientKeyStatus(status, clientKeyId).subscribe((response: any) => {
      if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
        this.foruscareService.showNotification(response.message, "success");
      }
      else {
        this.foruscareService.showNotification("Something wnet wrong, please try again later!", "danger");
      }
    });
  }

  copyClientKey(key: any, item: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = key;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    if (item == "secret") {
      this.foruscareService.showNotification("Client key copied successfully", "success");
    } else if (item == "id") {
      this.foruscareService.showNotification("Client ID copied successfully", "success");
    }
  }

  onSearch(value: string, field: string) {
    this.offset = 0;
    if (value != "") {
      this.isSearchMode = true;
    } else {
      this.isSearchMode = false;
      this.getClientApiKeys(0);
      return;
    }
    if (field == 'accountName') {
      this.userService.searchByAccountNameOrClientName(field, value, 10, this.offset).subscribe((response: any) => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          console.log("Response Code ==>", response.data);
          if (response.data != null) {
            console.log("Response ==>", response.data);
            if (response.data.length > 0) {
              console.log("Response ==>", response.data);
              this.apiKeys = response.data;
              this.totalRecords = response.totalCount;
            }
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      })
    } else if (field == 'clientName') {
      this.userService.searchByAccountNameOrClientName(field, value, 10, this.offset).subscribe((response: any) => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            console.log("Response ==>", response);
            if (response.data.length > 0) {
              
              this.apiKeys = response.data;
              this.totalRecords = response.totalCount;
            }
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      })

    }
  }
}